const customBannerPositions = (element) => {
    let triggered = false;
    const offset = 100;

    function checkPosition() {
        const rect = element.getBoundingClientRect();

        // quando o topo do elemento estiver próximo do topo da viewport
        if (rect.top <= offset && rect.bottom >= 0) {
            if (!triggered) {
                triggered = true;
                const textItemId = `#${element.getAttribute('data-content-id')}`;
                const textItemEl = document.querySelector(textItemId);
                if(textItemEl) {
                    const els = document.querySelectorAll('.custom-banners-item-wrap');
                    els.forEach((item) => {
                        item.classList.remove('active');
                    });
                    textItemEl.classList.add('active');
                }
            }
        } else {
            triggered = false; // permite disparar novamente
        }
    }

    window.addEventListener("scroll", checkPosition);
    window.addEventListener("resize", checkPosition);
}

const scrollToElementById = (id) => {
  const el = document.querySelector(id);
  const offset = 1000;

  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
}
//
const customJoy2Position = (items) => {
    function customJoy2PositionScroll () {
        const trigger = window.innerHeight * 0.8; // ponto de ativação (80% da tela)

        items.forEach((item, index) => {
            const rect = item.getBoundingClientRect();

            if (rect.top <= trigger) {
                // ativa esse e todos anteriores
                items.forEach((el, i) => {
                    if (i <= index) {
                        el.classList.add('active-mobile');
                    }
                });
            }
        });
    }
    window.addEventListener('scroll', customJoy2PositionScroll);
    window.addEventListener('resize', customJoy2PositionScroll);
    customJoy2PositionScroll();
}

document.addEventListener('DOMContentLoaded', () => {
    // custom banners
    const items = document.querySelectorAll('.joy-custom-2-item');
    if(items.length > 0){
        customJoy2Position(items);
    }
    const customBanners = document.querySelectorAll('.sticks-images-item');
    if(customBanners.length > 0) {
        customBanners.forEach((el) => {
            customBannerPositions(el);
        })
        // const clickItems = document.querySelectorAll('.custom-banners-item-wrap');
        // clickItems.forEach((item) => {
        //     item.addEventListener('click', () => {
        //         const imageItemId = `#${item.getAttribute('data-image-id')}`;
        //         scrollToElementById(imageItemId);
        //     })
        // });
    }
});